module.exports = __webpack_public_path__ + "img/banner-img.14fac423.png";